import React, {Component} from 'react';
import {connect} from 'react-redux';
import {deleteSchedule} from '../../actions/ClientActions';
import Modal from '../../components/Modal';

@connect(state => ({
    isSaving: state.modal.isSaving
}))
export default class ConfirmDeleteModal extends Component {
    handleDelete() {
        this.props.dispatch(deleteSchedule(this.props.scheduleId, this.props.type));
    }
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-danger disabled">Deleting...</button>) :
            (<button className="btn btn-danger" onClick={this.handleDelete.bind(this)}>Delete</button>);

        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Delete schedule?"}>
                <p>Are you sure?</p>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule/ConfirmDeleteModal.js